export default {
  data() {
    return {
      hoveredItems: {},
    };
  },
  methods: {
    isHovered(itemId) {
      return this.hoveredItems[itemId];
    },
    handleMouseEnter(itemId) {
      this.$set(this.hoveredItems, itemId, true);
    },
    handleMouseLeave(itemId) {
      this.$delete(this.hoveredItems, itemId);
    },
    handleTouchStart(itemId) {
      this.$set(this.hoveredItems, itemId, true);
    },
    handleTouchEnd(itemId) {
      this.$delete(this.hoveredItems, itemId);
    },
  }
};
